<template lang="pug"></template>

<script>
export default {
    name: 'BotaoLaudos',
    componentOptions: {
        title: 'Laudos',
        actions: [
            [
                {
                    name: 'Laudos',
                    iconClass: 'lyra-icon relatorio-rastreabilidade',
                    showView: false,
                    action: 'abrirLaudos',
                    route: 'Laudos',
                    nameTranslationKey: 'mensagens.menuLateral.laudos'
                }
            ]
        ]
    },

    methods: {
        abrirLaudos() {
            if (this.$route.name !== 'Laudo') {
                this.$router.push({ name: 'Laudo' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
